var map = {
	"./Testimoni_Akulaku.png": "7f46",
	"./Testimoni_David-TRON.png": "9cb4",
	"./Testimoni_PaperID.png": "a9ce",
	"./Testimoni_Stefanus.png": "227c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ef01";